import React, { useEffect, useRef } from "react";

import { FeatureGroup, MapContainer, TileLayer, Polygon } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";

import CurrentLocationButton from "../../Components/map/currentlocationbutton";
import MapSearch from "../../Components/map/search";

import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import classes from "./map.module.css";
import { bounds } from "leaflet";
const Map = ({ setLocations, existingCoordinates }) => {
  const mapRef = useRef(); 
  useEffect(() => {
    if (existingCoordinates && existingCoordinates.length > 0) {
        const map = mapRef.current;
        if (map) {
            const bounds = existingCoordinates.map(coord => [coord[1], coord[0]]); // Convert to LatLng array
      
            
            map.fitBounds(existingCoordinates);
              
        }
  
    }
}, []);


  const onCreated = (e) => {
    const layer = e.layer;
    const type = e.layerType;
    if (type === "polygon") {
      const latLngs = layer.getLatLngs()[0];
      const coordinates = latLngs.map((latLng) => ({
        long: latLng.lng,
        lat: latLng.lat,
      }));
      setLocations(coordinates);
   
    }
   
  
  };



  return (
    <MapContainer center={[0, 0]} zoom={30} className={classes.mapContainer} ref={mapRef}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      <FeatureGroup>
        {existingCoordinates && <Polygon positions={existingCoordinates} />}
        <EditControl
          position="topright"
          onCreated={onCreated}
          draw={{
            rectangle: false,
            circle: false,
            circlemarker: false,
            marker: false,
            polyline: false,
          }}
        />
      </FeatureGroup>
      <MapSearch />
      <CurrentLocationButton />
    </MapContainer>
  );
};

export default Map;
